import request from "@/utils/request";

// 开启文件编辑
export const  beginFileEdit =(data) =>{
    return request({
        url: "/businessservice/officeEdit/begin",
        method:"post",
        data: data
    })
}


// 保存文件修改
export const  saveFileEdit =(query) =>{
    return request({
        url: "/businessservice/officeEdit/save",
        method:"get",
        params: query
    })
}